// Import model
import { NumberFieldOptions } from '../models/NumberFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for NumberFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class NumberFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a NumberFieldOptions instance
   */
  static deserialize(json: string): NumberFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a NumberFieldOptions instance
   */
  static fromObject(obj: any): NumberFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to NumberFieldOptions');
    }


    const instance: NumberFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      decimalPlaces: obj['DecimalPlaces'] as number | undefined,
      minimum: obj['Minimum'] as number | undefined,
      maximum: obj['Maximum'] as number | undefined,
      excludeMaximum: obj['ExcludeMaximum'] as boolean | undefined,
      excludeMinimum: obj['ExcludeMinimum'] as boolean | undefined,
      multipleOf: obj['MultipleOf'] as number | undefined,
      style: obj['Style'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of NumberFieldOptions instances
   */
  static deserializeArray(json: string): NumberFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a NumberFieldOptions instance to a JSON string
   */
  static serialize(instance: NumberFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a NumberFieldOptions instance to a plain object
   */
  static toObject(instance: NumberFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'DecimalPlaces': instance.decimalPlaces,
      'Minimum': instance.minimum,
      'Maximum': instance.maximum,
      'ExcludeMaximum': instance.excludeMaximum,
      'ExcludeMinimum': instance.excludeMinimum,
      'MultipleOf': instance.multipleOf,
      'Style': instance.style,
    };
  }

  /**
   * Serializes an array of NumberFieldOptions instances to a JSON string
   */
  static serializeArray(instances: NumberFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
